import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
// import ChooseIdentity from "./Register";
import { GetToken } from "../Components/CRUDPage/FetchData";

// /user/login，body是{"email":"dev_admin","password":"dev_admin"}
function Login(){
    const [loginInput, setLoginInput] = useState({"email":null, "password": null});

    const navigate = useNavigate();
    
    const getToken = async() => {
        // let loginProfile = {
        //     email: "dev_admin",
        //     password: "dev_admin",
        // };

        let loginProfile = loginInput;
        
        GetToken(loginProfile)
        .then(data => {
            // console.log(data)
            if(!data.access_token) throw new Error('fail to login')
            sessionStorage.setItem('isLoggedIn', true);
            sessionStorage.setItem('access_token', data.access_token);
            // sessionStorage.setItem('refresh_token', data.refresh_token);
            navigate('/home');
        })
        .catch(error => {
            console.log("error:",error)
            alert("登入失敗")
        })

        // let returnToken = (loginInput.email===null || loginInput.password===null) ? null : GetToken(loginInput);
    }

    const setLogin = (value, target) => {
        let updateValue = !value || value==='' ? null : value;
        setLoginInput(prevState => (
            {
                ...prevState,
                [target]: updateValue
            }
        ));
    }

    return(
        <div className="items-center justify-center flex flex-col h-screen bg-[#2058a2] text-[#fff]">
            <h1 className="text-4xl font-bold">青光眼追蹤管理平台</h1>
            <div id="inputs" className="my-5 text-2xl">
                <div className="my-5">
                    <label htmlFor="account_input" className="mx-5">帳號</label>
                    <input id="account_input" className="text-[#000] pl-1" type="text" onChange={(event) => setLogin(event.target.value, "email")}></input>
                </div>
                <div className="my-5 ">
                    <label htmlFor="password_input" className="mx-5" >密碼</label>
                    <input id="password_input" className="text-[#000] pl-1" type="password" onChange={(event) => setLogin(event.target.value, "password")}></input>
                </div>
                    <Link to="/forgot_password" className="mx-5 text-xl underline">忘記密碼</Link>
                <div className="my-5 ">
                    {/* <Link to="/home"> */}
                        <button id="login_button" onClick={event => getToken()} className="mx-5 bg-gradient-to-br from-[#7fdc16] to-[#4d860d] rounded-lg px-3 py-1 font-bold" >登入</button>
                    {/* </Link> */}
                    <Link to="/register">
                        <button id="register" className="bg-gradient-to-br from-[#59cebe] to-[#388379] rounded-lg px-3 py-1 font-bold">申請帳號</button>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default Login;